import { ArrowNarrowDownIcon } from "@/components/Icons/ArrowNarrowDownIcon";
import { ArrowNarrowRightIcon } from "@/components/Icons/ArrowNarrowRightIcon";
import { ArrowsUpIcon } from "@/components/Icons/ArrowsUpIcon";
import { Label } from "@/components/Label/Label";
import { useTranslation } from "@/translations";

type FahWidgetScoreReferenceLabelProps = {
  currValue: number;
  referenceValue: number;
};
export const FahWidgetScoreReferenceLabel = ({
  currValue,
  referenceValue,
}: FahWidgetScoreReferenceLabelProps): React.ReactNode => {
  const { t } = useTranslation();
  if (!currValue && !referenceValue) {
    return (
      <Label theme="blue" size="lg" isUppercase={false}>
        <ArrowNarrowRightIcon />
        {t("common.label.not-applicable")}
      </Label>
    );
  }
  const difference = currValue - referenceValue;
  let label = t("component.analytics-widget.fah.label.neutral");
  let icon = <ArrowNarrowRightIcon />;
  let theme: "green" | "yellow" | "blue" = "blue";
  if (difference > 0) {
    icon = <ArrowsUpIcon />;
    theme = "green";
    label = t("component.analytics-widget.fah.label.increased", {
      difference: difference.toFixed(1),
    });
  } else if (difference < 0) {
    icon = <ArrowNarrowDownIcon />;
    theme = "yellow";
    label = t("component.analytics-widget.fah.label.decreased", {
      difference: difference.toFixed(1),
    });
  }

  return (
    <Label
      size="lg"
      isUppercase={false}
      icon={icon}
      {...{
        theme,
      }}
    >
      {label}
    </Label>
  );
};
